import { memoize } from '../memoize';

export const getTextWidth: (text: string, className?: string) => number = memoize((text, className = '') => {
  if (!text) {
    return 0;
  }

  const span = document.createElement('span');
  span.className = className;
  span.innerHTML = text;
  span.style.position = 'absolute';
  span.style.visibility = 'hidden';

  document.body.appendChild(span);
  const width = span.offsetWidth;
  document.body.removeChild(span);

  return width;
});
